import { MecordColors } from "Constants/Color";
import React from "react";

interface FilePreviewProps {
  file?: File | string | null;
  label?: string;
  showFileName?: boolean; // 👈 optional
}

const FilePreview2: React.FC<FilePreviewProps> = ({
  file,
  label = "Document",
  showFileName = false, // 👈 default false
}) => {
  if (!file) {
    return (
      <div className="text-muted" style={{ fontSize: 13 }}>
        No document available
      </div>
    );
  }

  const fileUrl = typeof file === "string" ? file : URL.createObjectURL(file);

  const fileName = typeof file === "string" ? file.split("/").pop() : file.name;

  const handlePreview = () => {
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      className="d-flex align-items-center gap-2"
      style={{ minHeight: "32px" }}
    >
      {/* 📄 Optional File Name */}
      {showFileName ? (
        <span
          className="text-truncate"
          style={{
            fontSize: 13,
            maxWidth: "200px",
          }}
          title={fileName}
        >
          {fileName ? fileName : "View Document"}
        </span>
      ) : (
        <span
          className="text-truncate"
          style={{
            fontSize: 13,
            maxWidth: "200px",
          }}
          title={fileName}
        >
          {"View Document"}
        </span>
      )}

      {/* 👁 Preview Icon */}
      <i
        className="bi bi-eye"
        title={`Preview ${label}`}
        onClick={handlePreview}
        style={{
          cursor: "pointer",
          color: MecordColors.ThemeBGColor,
          fontSize: "16px",
        }}
      />
    </div>
  );
};

export default FilePreview2;
